import React, {useEffect, useRef} from "react";
import {ImageCarousel} from "../ImageCarousel/ImageCarousel";
import {VehicleInfoSection} from "../vehicleInfoSection/VehicleInfoSection";
import {VehicleDataDTO} from "../../../../../../../../../../api/generated";
import styles from "./VehicleCard.module.css";

interface VehicleCardProps {
    brandColour: string
    vehicle: VehicleDataDTO
    reportContentHeight: (headerHeight: number, derivativeHeight: number) => void
    derivativeHeight: number
    headerHeight: number
    isInteractive: boolean
    selectedImageIndex?: number
    onSelectedImageIndexChange?: (index: number) => void
}

export const VehicleCard: React.FC<VehicleCardProps> = ({
                                                            brandColour,
                                                            vehicle,
                                                            reportContentHeight,
                                                            derivativeHeight,
                                                            headerHeight,
                                                            isInteractive,
                                                            selectedImageIndex,
                                                            onSelectedImageIndexChange
                                                        }) => {
    const headingRef = useRef<HTMLHeadingElement>(null);
    const derivativeRef = useRef<HTMLParagraphElement>(null);

    useEffect(() => {
        if (headingRef.current && derivativeRef.current) {
            const headingHeight = headingRef.current.clientHeight;
            const derivativeHeight = derivativeRef.current.clientHeight;
            reportContentHeight(headingHeight, derivativeHeight);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicle, headingRef, derivativeRef]);

    return (
        <div className={styles.card}>
            <ImageCarousel
                brandColour={brandColour}
                images={vehicle.image_list}
                isInteractive={isInteractive}
                selectedIndex={selectedImageIndex}
                onSelectedIndexChange={onSelectedImageIndexChange}
            />
            <VehicleInfoSection
                vehicle={vehicle}
                headingRef={headingRef}
                derivativeRef={derivativeRef}
                headerHeight={headerHeight}
                derivativeHeight={derivativeHeight}
            />
        </div>
    );
};
